import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "finance-bar"
}
const _hoisted_2 = { class: "vip-value" }
const _hoisted_3 = { class: "vip-label" }

import { ref, reactive } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from "@/store";


export default {
  __name: 'FinanceBar',
  setup(__props) {

const userStore = useUserStore();
const { uid, vip } = storeToRefs(userStore);

return (_ctx, _cache) => {
  const _directive_audio = _resolveDirective("audio")

  return (_ctx.$router.currentRoute.value.name === 'game' && _unref(uid))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "action-btn",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.push({ name: 'withdraw' })))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('common.withdraw').toUpperCase()), 1)
        ])), [
          [_directive_audio]
        ]),
        _createElementVNode("div", {
          class: "user-vip",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push({ name: 'profile' })))
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(vip)), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('vip.vip').toUpperCase()), 1)
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "action-btn deposit",
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.$router.push({ name: 'recharge' })))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('common.deposit').toUpperCase()), 1)
        ])), [
          [_directive_audio]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}